class PriceUtil {
  static format(price: number): string {
    const formatter = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 });

    return formatter.format(price);
  }
}

export default PriceUtil;
